import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import dataModel from '../../models/DataModel';
import CheckBox from '../CheckBox';
import './IntegrationTypes.scss';

export default class IntegrationTypes extends React.Component {
  
  constructor(props) {
    IntegrationTypes.propTypes = {
      company: PropTypes.object.isRequired,
    };
    super(props);
    this.toggleIntegration = this.toggleIntegration.bind(this);
  }

  toggleIntegration(checked, dataSource, e) {
    const { company } = this.props;
    const clonedCompany = _.cloneDeep(company);
    let integrations = clonedCompany.features && clonedCompany.features.integration ? clonedCompany.features.integration.integrations : null;
    if (integrations) {
      let updateNeeded = false;
      integrations.forEach(integration => {
        if (integration.type == dataSource) {
          integration.enabled = checked;
          updateNeeded = true;
        }
      });
      if (updateNeeded) {
        dataModel.companiesDAO.updateCompany(clonedCompany);
      }
    }
  }

  render() {
    const { company } = this.props;
    let smartsheetCheck = null;
    let quickbaseCheck = null;
    let integrations = company.features && company.features.integration ? company.features.integration.integrations : null;
    if (integrations) {
      integrations.forEach(integration => {
        if (integration.type == 'smartsheet') {
          smartsheetCheck = (
            <div className="integration-types__check">
              <CheckBox className="integration-types__smartsheet-check" key='integration-type-smartsheet' checked={integration.enabled} dataSource="smartsheet" toggleCheckBox={this.toggleIntegration}/>
              <div className="integration-types__smartsheet-text">SmartSheet</div>
            </div>
          );
        }
        else if (integration.type == 'quickbase') {
          quickbaseCheck = (
            <div className="integration-types__check">
              <CheckBox className="integration-types__quickbase-check" key='integration-type-quickbase' checked={integration.enabled} dataSource="quickbase" toggleCheckBox={this.toggleIntegration}/>
              <div className="integration-types__quickbase-text">Quick Base</div>
            </div>
          );
        }
      });
    }
    return (
      <div className="integration-types">
        {smartsheetCheck}
        {quickbaseCheck}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/IntegrationTypes/index.js